import React, { useState } from 'react'
import Title from '@components/ItemPage/Details/Important/Title'
import Condition from '@components/ItemPage/Details/Important/Condition'
import Quantity from '@components/ItemPage/Details/Important/Quantity'
import CurrentBid from '@components/ItemPage/Details/Important/CurrentBid'
import MSRP from '@components/ItemPage/Details/Important/MSRP'
import Buttons from '@components/ItemPage/Details/Important/Buttons'
import LastUpdated from '@components/ItemPage/Details/Important/LastUpdated'
import { useItemPage } from '@components/ItemPage/Layout/ItemPageContext'
import Status from '@components/ItemPage/Details/Important/Status'

const Important = () => {
  const { itemState, modal, lastUpdated, itemHandler, auction } = useItemPage()
  const [loadingBid, setLoadingBid] = useState<any>(false)

  const {
    title,
    condition,
    itemClosed,
    msrp,
    bidStatus,
    removed,
    quantity,
    initialQuantity,
  } = itemState

  return (
    <div className="mb-4 p-4">
      <Title>{title}</Title>
      <div className="flex gap-2 flex-wrap">
        <Status
          bidStatus={bidStatus}
          itemClosed={itemClosed}
          itemRemoved={removed}
        />
        <Condition condition={condition} />
        <Quantity
          quantity={initialQuantity === undefined ? quantity : initialQuantity}
        />
      </div>

      <div className="flex gap-4 xs:gap-6 my-4">
        <CurrentBid loadingBid={loadingBid} />
        <MSRP msrp={msrp} />
      </div>
      <Buttons
        itemState={itemState}
        itemHandler={itemHandler}
        modal={modal}
        auction={auction}
        loadingBid={loadingBid}
        setLoadingBid={setLoadingBid}
        lastUpdated={lastUpdated}
      />
    </div>
  )
}

export default Important
